import { Routes } from '@angular/router'
import { Layout } from './layout/layout'
import { hasUserTypeGuard, isAuthenticatedGuard, isNotAuthenticatedGuard } from '@core/auth'
import { USER_TYPES } from '@core/data'

export const routes: Routes = [
  {
    path: '',
    component: Layout,
    canActivate: [isAuthenticatedGuard],
    children: [
      {
        path: '',
        redirectTo: '/championships',
        pathMatch: 'full'
      },
      {
        path: 'championships',
        loadChildren: () => import('@features/championships/championships.routes').then(m => m.routes)
      },
      {
        path: 'tienda',
        loadChildren: () => import('@features/prizes/prizes.routes').then(m => m.routes)
      },
      {
        path: 'sala_de_prensa',
        loadChildren: () => import('@features/blog/blog.routes').then(m => m.routes)
      },
      {
        path: 'centro_de_entrenamiento',
        loadChildren: () => import('@features/entrenamiento/entrenamiento.routes').then(m => m.routes)
      },
      {
        path: 'team',
        loadComponent: () => import('@features/users/pages/team-page/team-page').then(m => m.TeamPage),
        canActivate: [hasUserTypeGuard([USER_TYPES.GERENTE, USER_TYPES.SUPERVISOR, USER_TYPES.JEFE])]
      },
      {
        path: 'tiros-libres',
        loadChildren: () => import('@features/tiros-libres/tiros-libres.routes').then(m => m.routes)
      },
      {
        path: 'profile',
        loadChildren: () => import('@features/users/users.routes').then(m => m.routes)
      },
      {
        path: 'sala_de_trofeos',
        loadChildren: () => import('@features/sala-de-trofeos/sala-de-trofeos.routes').then(m => m.routes),
        canActivate: [hasUserTypeGuard([USER_TYPES.PILOTO, USER_TYPES.SUPERVISOR, USER_TYPES.JEFE])]
      },
      {
        path: 'reglamento',
        loadComponent: () => import('./pages/ayuda-reglamento-page/ayuda-reglamento-page').then(m => m.AyudaReglamentoPage)
      }
    ]
  },
  {
    path: 'complete_signup',
    canActivate: [isAuthenticatedGuard],
    loadComponent: () => import('@features/auth/pages/complete-signup-page/complete-signup-page').then(m => m.CompleteSignupPage)
  },
  {
    path: '',
    canActivate: [isNotAuthenticatedGuard],
    loadChildren: () => import('@features/auth/auth.routes').then(m => m.routes)
  }
]
